export default __webpack_public_path__ + "static/media/logo.bd1b89db.svg";